export default __webpack_public_path__ + "static/media/logoGrey.57d4e40a.png";